import { Filter, FilterActions } from '@gogame/filters';
import React from 'react';
import LockAction from './LockAction';

const PayToFilter = ({ locked, onLock, name, ...props }) => {
  return (
    <Filter.DatePicker
      title={'Pay to'}
      name={name}
      placeholder={''}
      maxDate={new Date()}
      withClear={false}
      compareActions={[<FilterActions.Equalize />]}
      actions={[<LockAction locked={locked} onLock={onLock} />]}
      {...props}
    />
  );
};
export default PayToFilter;
